import { render, staticRenderFns } from "./Bookkeeping.vue?vue&type=template&id=7a447f4c&"
import script from "./Bookkeeping.vue?vue&type=script&lang=js&"
export * from "./Bookkeeping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports